import { useEffect, useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import { handleApiError } from "../apiErrorHandler";

const CustomerNotes = ({ customerId }) => {
    const [notes, setNotes] = useState([]);
    const [newNote, setNewNote] = useState("");

    useEffect(() => {
        const fetchNotes = async () => {
            try {
                const response = await axiosInstance.get(`/api/customer-notes/?customer_id=${customerId}`);
                setNotes(response.data);
            } catch (error) {
                handleApiError(error);
            }
        };

        fetchNotes();
    }, [customerId]);

    const addNote = async () => {
        if (!newNote.trim()) return;
        try {
            const response = await axiosInstance.post(`/api/customer-notes/`, { customer: customerId, note: newNote });
            setNotes([response.data, ...notes]);
            setNewNote("");
        } catch (error) {
            handleApiError(error);
        }
    };

    return (
        <div className="p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold">Customer Notes</h3>
            <textarea value={newNote} onChange={(e) => setNewNote(e.target.value)} className="w-full p-2 border"></textarea>
            <button onClick={addNote} className="mt-2 bg-blue-500 text-white px-4 py-1 rounded">
                Add Note
            </button>
            <ul className="mt-2">
                {notes.map((note) => (
                    <li key={note.id} className="border-b p-2">
                    <strong>{note.created_by_name} </strong><small>({new Date(note.created_at).toLocaleString()})</small> : {note.note} 
                </li>
                ))}
            </ul>
        </div>
    );
};

export default CustomerNotes;
